import Vue from 'vue';
import axios from "axios";
import VueRouter from 'vue-router';
import {AllRouter} from './router';
import {Modal} from 'iview'
import {Message} from 'iview'
import Cookies from 'js-cookie';

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
    mode: 'history',
    routes: AllRouter
};

const router = new VueRouter(RouterConfig);

//路由的全局前置守卫 to:即将要进去的路由目标 from 当前到离开的路由目标
router.beforeEach((to, from, next) => {
    let groupid = localStorage.getItem("Groupid");
    if (groupid) {
      var id = localStorage.getItem("Groupid");
      let token = localStorage.getItem("token");
      if (id) {
        axios
        .get("https://api.lotusdata.com/operations/v1/competence/list/" + id, {
          headers: { Authorization: token },
        })
        .then((res) => {
                        console.log(to, 'to')
          if (res.data.code === 0) {
            var list = res.data.data.res_data;
            if (list != null) {
              for (let i in list) {
                let {Competence, DataCreate, DataDelete, DataExport, DataSelect, DataUpdate}  = list[i]
                if (Competence === to.name) {
                    localStorage.setItem("DataUpdate", DataUpdate)
                    localStorage.setItem("DataCreate", DataCreate)
                    localStorage.setItem("DataDelete", DataDelete)
                    localStorage.setItem("DataExport", DataExport)
                    localStorage.setItem("DataSelect", DataSelect)
                }
              }
            } else {
            }
            next()
          } else {
            if (to.path == '/') {
                next()
            } else {
                next({ path: '/' })
            }
          }
        });
      }
    } else {
        console.log(to)
        if (to.path == '/') {
            next()
        } else {
            next({ path: '/' })
        }
    }
    return
           //next({ path: '/' })跳到一个不同的地址
})
//路由的全局后置钩子
router.afterEach((to, from) => {
    // ...
    window.scrollTo(0, 0);
})

export default router;
